import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Gauntle render failure', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <main className="center-screen">
          <section className="panel error-panel" role="alert">
            <p className="eyebrow">Something went wrong</p>
            <h1>The game could not continue.</h1>
            <p>{this.state.error.message}</p>
            <button className="button" onClick={() => window.location.reload()}>
              Reload locally
            </button>
          </section>
        </main>
      );
    }
    return this.props.children;
  }
}
